export enum ValidatorType {
    CONTAINERS = 0,
    ORDERS = 1,
    RECEPTION_PLACE = 2,
}